/// <reference types="vite/client" />
import {
  createRootRoute,
  Outlet,
} from '@tanstack/react-router'
import * as React from 'react'
import { DefaultCatchBoundary } from '~/components/DefaultCatchBoundary'
import { NotFound } from '~/components/NotFound'
import { CookieConsent } from '~/components/CookieConsent'
import { CustomerServiceChatbot } from '~/components/customer-service-chatbot'
import { FeedbackButton } from '~/components/FeedbackButton'

// This is a pure client-side SPA (no SSR). The <html>/<head>/<body> shell is
// already in index.html — do NOT render those elements here. Doing so causes
// the browser to silently eject the nested HTML elements out of the React-
// managed subtree, which breaks layout and produces a blank/black screen on
// pages that rely on viewport-height CSS (sign-in, sign-up, etc.).

function RootComponent() {
  return (
    <>
      {/* WCAG 2.4.1 Bypass Blocks — skip-to-main-content link. Hidden until
        * keyboard focus reaches it (first Tab from the address bar), then
        * pops as a high-contrast button that jumps the user past nav into
        * the page's `<main id="main-content">`. Every route that ships a
        * top-level `<main>` carries that id; routes without one fall through
        * (focus stays on the link, no harm). See WCAG-AUDIT-2026-05-31.md
        * § M-04. */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:rounded-md focus:bg-[#00f0ff] focus:text-black focus:font-mono focus:font-bold focus:outline-2 focus:outline-offset-2 focus:outline-[#00f0ff]"
      >
        Skip to main content
      </a>
      <Outlet />
      <FeedbackButton />
      <CustomerServiceChatbot />
      <CookieConsent />
    </>
  )
}

export const Route = createRootRoute({
  component: RootComponent,
  errorComponent: DefaultCatchBoundary,
  notFoundComponent: () => <NotFound />,
})
